import { useTranslation } from 'react-i18next'
import { TbFilter } from 'react-icons/tb'
// Antd
import { Select } from 'antd'
import styles from './styles.module.scss'

const { Option } = Select

type Option = { value: any; label: string }

interface SelectFilterInterface {
  value: string
  setValue: (val: string) => void
  options: Option[]
  placeholder?: string
  hideIcon?: boolean
  noBadge?: boolean
}

const SelectFilter: React.FC<SelectFilterInterface> = ({
  value,
  setValue,
  options,
  placeholder = '',
  hideIcon = false,
  noBadge = false
}) => {
  const { t } = useTranslation()

  const props = {
    value,
    onChange: setValue,
    style: { width: 240 },
    optionLabelProp: 'label',
    allowClear: true,
    tagRender: props => {
      const { label, value } = props

      return (
        <div className={styles.options}>
          <div className="optionContainer">
            <div className={`badge badge-${value}`} />
            <div>{t(label)}</div>
          </div>
        </div>
      )
    }
  }

  return (
    <div className={styles.filterLayout}>
      {!hideIcon && (
        <>
          <TbFilter color="#BACAE2" fontSize={'1.5rem'} />
          <p>{t('FILTER_KEY', 'Filtro')}</p>
        </>
      )}
      <Select {...props} placeholder={placeholder}>
        {options.map((opt, i) => (
          <Option
            key={`filter-opt-${i}`}
            className={styles.options}
            value={opt.value}
            label={t(opt.label)}
          >
            <div className="optionContainer">
              {!noBadge && <div className={`badge badge-${opt.value}`} />}
              <div>{t(opt.label)}</div>
            </div>
          </Option>
        ))}
      </Select>
    </div>
  )
}

export default SelectFilter
